import apiClient from './index';

export const login = (credentials) => apiClient.post('/login', credentials);
export const logout = (credentials) => apiClient.post('/logout', credentials);
export const forgotPassword = (credentials) => apiClient.post('/forgotPassword', credentials);
export const changePassword = (credentials) => apiClient.post('/forgotPassword', credentials);